export default "__VITE_ASSET__Be$B5wTl__"